export default __webpack_public_path__ + "static/media/SOL.fca018b8.png";